import * as React from 'react';

import { AIGenerateBrandedNewIcon } from '@coursera/cds-icons';

import CoachButton from 'bundles/ai-coach-platform/components/building-blocks/CoachButton';

import _t from 'i18n!nls/ai-coach-platform';

import type { Props as CoachButtonProps } from './CoachButton';

export type Props = { children: string; showSparkleIcon?: boolean } & CoachButtonProps;

/**
 * Simple wrapper around CoachButton to provide some specific styles.
 */
export const CoachTriggerButton = (props: Props): React.ReactElement => {
  const { variant = 'secondary', children, showSparkleIcon = true, ...rest } = props;

  return (
    <CoachButton
      variant={variant}
      size="small"
      aria-label={_t('#{label}, Coursera AI trigger', { label: children })}
      icon={showSparkleIcon ? <AIGenerateBrandedNewIcon /> : undefined}
      iconPosition="before"
      {...rest}
    >
      {children}
    </CoachButton>
  );
};

export default CoachTriggerButton;
